export const normalizeMealType = (value) => String(value || "").trim().toLowerCase();

export const normalizeDateOnly = (value) => {
  if (!value) return "";
  return String(value).split("T")[0];
};

export const getAddressAreaId = (address) => {
  const value =
    address?.AreaId ??
    address?.AreaID ??
    address?.areaId ??
    null;
  const numericValue = Number(value);
  return Number.isFinite(numericValue) && numericValue > 0 ? numericValue : null;
};

export const getAddressDivision = (address) =>
  String(address?.Division || address?.division || address?.Route || "").trim().toLowerCase();

export const normalizeAreaName = (value) =>
  String(value || "")
    .trim()
    .replace(/\s+/g, " ")
    .toLowerCase();

export const getAddressAreaName = (address) =>
  normalizeAreaName(address?.Area || address?.City || address?.area || address?.city);

export const getBlockedMealTypesForAddress = (restrictionRows, address, dateStr) => {
  const rows = Array.isArray(restrictionRows) ? restrictionRows : [];
  const addressAreaName = getAddressAreaName(address);
  const addressDivision = getAddressDivision(address);
  const selectedDate = normalizeDateOnly(dateStr);

  return new Set(
    rows
      .filter((row) => {
        if (Number(row?.IsAvail) !== 0) return false;
        if (selectedDate && normalizeDateOnly(row?.MenuDate) !== selectedDate) return false;

        const rowAreaName = normalizeAreaName(row?.Area);
        if (rowAreaName) {
          return addressAreaName === rowAreaName;
        }

        return addressDivision && String(row?.Division || "").trim().toLowerCase() === addressDivision;
      })
      .map((row) => normalizeMealType(row?.ItemType || row?.Item_Type))
      .filter(Boolean)
  );
};

export const formatMealType = (value) => {
  const mealType = normalizeMealType(value);
  return mealType ? mealType.charAt(0).toUpperCase() + mealType.slice(1) : "Meal";
};

export const MEAL_TYPES = ["breakfast", "lunch", "dinner"];

export const getRestrictionWording = (contentRows) => {
  const row = Array.isArray(contentRows) ? contentRows[0] : null;

  return {
    header: String(row?.header || "Heavy rain in").trim(),
    content: String(
      row?.Content ||
        row?.content ||
        "delivery is temporarily suspended for this address. Your selected address and cart were not changed."
    ).trim(),
  };
};

export const getBlockedCartItemsForAddress = ({ cart, findMenuItem, restrictionRowsByDate, address }) => {
  const blockedItems = [];

  Object.entries(cart || {}).forEach(([date, itemsObj]) => {
    const blockedMealTypes = getBlockedMealTypesForAddress(restrictionRowsByDate?.[date], address, date);
    if (!blockedMealTypes.size) return;

    Object.entries(itemsObj || {}).forEach(([itemId, qty]) => {
      if (Number(qty) <= 0) return;

      const item = findMenuItem(itemId);
      const mealType = normalizeMealType(item?.type || item?.raw?.Item_Type || item?.Item_Type);
      if (!blockedMealTypes.has(mealType)) return;

      blockedItems.push({
        date,
        itemId,
        qty,
        name: item?.name || item?.Item_Desc1 || `Item ${itemId}`,
        mealType,
        price: Number(item?.price || 0),
      });
    });
  });

  return blockedItems;
};

export const getCartRestrictionForAddress = ({
  cart,
  findMenuItem,
  restrictionRowsByDate,
  restrictionContentRowsByDate,
  address,
}) => {
  const blockedMealTypeSet = new Set();
  const cartDates = Object.keys(cart || {});

  cartDates.forEach((date) => {
    getBlockedMealTypesForAddress(restrictionRowsByDate?.[date], address, date).forEach((mealType) => {
      blockedMealTypeSet.add(mealType);
    });
  });

  const affectedItems = getBlockedCartItemsForAddress({ cart, findMenuItem, restrictionRowsByDate, address });
  const wordingDate = affectedItems[0]?.date || cartDates[0];

  return {
    affectedItems,
    blockedMealTypes: Array.from(blockedMealTypeSet),
    wording: getRestrictionWording(restrictionContentRowsByDate?.[wordingDate]),
  };
};
